import { useMemo } from 'react';
import { ASK_USER_APPROVAL_KIND } from '../../contracts/approval-kinds';
import type { PendingToolApproval } from '../../contracts/tool-approval.types';

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export const letterFor = (index: number): string => LETTERS[index] ?? String(index + 1);

export const usePaginationLabel = (
  allPending: PendingToolApproval[],
  approvalId: string
): { paginationLabel: string | null } =>
  useMemo(() => {
    const clarifications = allPending.filter(
      (a) => a.approvalKind === ASK_USER_APPROVAL_KIND
    );
    if (clarifications.length <= 1) return { paginationLabel: null };
    const idx = clarifications.findIndex((a) => a.approvalId === approvalId);
    if (idx === -1) return { paginationLabel: null };
    return { paginationLabel: `${idx + 1} of ${clarifications.length}` };
  }, [allPending, approvalId]);
